import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "PILOTS",
    applicationRights: Rights,
    title: 'Losoversikt',
    text: 'Losoversikt',
    icon: 'users-three',
    showOnDashboardByDefault: false,
    url: "/pilot/station",
    sequenceNo: 7000,
    routes: Routes
})
